var _circle, _circle2, _path, _path2, _path3, _circle3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPumpBoosterStationCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4402,
    cy: 25.0926,
    r: 4.94021,
    stroke: "#637381"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4401,
    cy: 25.0913,
    r: 4.56978,
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3696 16.6953H16.8805V25.0649L15.9389 22.6237L14.3696 20.8801V16.6953Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.3477L18.1619 15.8585H13.0881L15.625 13.3477Z",
    fill: "#CBDFF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10L18.1619 12.5109H13.0881L15.625 10Z",
    fill: "#CBDFF7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 9,
    r: 6,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7811 1.5H18.2447C18.028 1.5 17.8112 1.59167 17.6611 1.74167L13.7506 5.65C13.6005 5.8 13.5088 6.01667 13.5088 6.23333V11.7583C13.5088 11.9833 13.6005 12.1917 13.7506 12.35L17.6527 16.25C17.8112 16.4083 18.028 16.5 18.2447 16.5H23.7728C23.9979 16.5 24.2064 16.4083 24.3648 16.2583L28.2669 12.3583C28.3446 12.2807 28.406 12.1884 28.4475 12.0869C28.489 11.9853 28.5098 11.8764 28.5087 11.7667V6.23333C28.5087 6.00833 28.417 5.8 28.2669 5.64167L24.3648 1.74167C24.2147 1.59167 23.9979 1.5 23.7811 1.5ZM21.0129 13.4167C20.4126 13.4167 19.929 12.9333 19.929 12.3333C19.929 11.7333 20.4126 11.25 21.0129 11.25C21.6133 11.25 22.0969 11.7333 22.0969 12.3333C22.0969 12.9333 21.6133 13.4167 21.0129 13.4167ZM21.0129 9.83333C20.5544 9.83333 20.1791 9.45833 20.1791 9V5.66667C20.1791 5.20833 20.5544 4.83333 21.0129 4.83333C21.4715 4.83333 21.8467 5.20833 21.8467 5.66667V9C21.8467 9.45833 21.4715 9.83333 21.0129 9.83333Z",
    fill: "#FF4842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpBoosterStationCritical);
export default __webpack_public_path__ + "static/media/pump_booster_station_critical.264ed8a82472f510331d26d022bf34e7.svg";
export { ForwardRef as ReactComponent };